export default "__VITE_ASSET__tRmCB9aG__"